// test922
(922 && 0);
